import { Injectable } from '@angular/core';
import {BackendService} from "./backend.service";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {ResponseDto} from "../dto/response.dto";

@Injectable({
  providedIn: 'root'
})
export class SegmentService {

  private urlPrefix = '/api/segment';

  constructor(private backend: BackendService) {}

  getSegmentList(): Observable<any> {
    const url = `${this.urlPrefix}/list`;
    return this.backend.get(url).pipe(
        map((response: ResponseDto) => response.response)
    );
  }
}
